var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgMailIcon = function SvgMailIcon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 20,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 4.4187V16.25C25.0001 17.2065 24.6346 18.1268 23.9784 18.8228C23.3222 19.5187 22.4249 19.9376 21.47 19.9937L21.25 20H3.75C2.79349 20 1.87311 19.6345 1.17717 18.9783C0.481241 18.3221 0.0623656 17.4248 0.00625014 16.47L0 16.25V4.4187L11.8062 12.29L11.9513 12.3725C12.1221 12.4559 12.3098 12.4993 12.5 12.4993C12.6902 12.4993 12.8779 12.4559 13.0487 12.3725L13.1938 12.29L25 4.4187Z",
    fill: "#404D61"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2504 0C22.6004 0 23.7841 0.7125 24.4441 1.78375L12.5004 9.74625L0.556641 1.78375C0.870131 1.27478 1.30075 0.848126 1.81261 0.539362C2.32446 0.230598 2.90271 0.0486716 3.49914 0.00874996L3.75039 0H21.2504Z",
    fill: "#404D61"
  })));
};
export default SvgMailIcon;